import { MAX_4U_WIDTH, MAX_NARROW_WIDTH_PRINT, CATEGORY, SERIES, VALUE, POINT, SYMBOL } from '../data/constants';
import * as transform from './transform';
import * as element from '../util/element';
import * as format from '../data/format';

const MIN_ITEM_CHARS = 16;
const MAX_ITEM_CHARS = 32;
const MIN_CHARS_RATIO = MIN_ITEM_CHARS / MAX_4U_WIDTH;


export function preRender(data, options) {
  if (__MARKETWATCH__) {
    if (options.size === 'marketwatch-ZT') {
      return data;
    }
  }
  data.legend = {
    enabled: options.legend.enabled && options.type !== 'pie' &&
      options.size !== 'marketwatch-ZT',
    navigation: { enabled: false },
  };
  if (data.legend.enabled) {
    options.forceLegendTop = options.legend.layout === 'right' &&
      ((options.print && options.width <= MAX_NARROW_WIDTH_PRINT) ||
       (!options.print && options.width <= MAX_4U_WIDTH));
    styleLegend(data, options);
    compileLegendText(data, options);
    positionLegend(data, options);
  }
  return data;
}

function positionLegend(data, options) {
  const LH = parseFloat(options.styles.normal.lineHeight);
  if (options.forceLegendTop) {
    options.legend.layout = 'top';
  }
  switch (options.legend.layout) {
    case 'top':
      data.legend.layout = 'horizontal';
      data.legend.align = 'left';
      data.legend.verticalAlign = 'top';
      if (options.print) {
        data.legend.margin = options.type === 'bar' ? 8 : 4;
      }
      if (options.id === 'D') {
        data.legend.margin = 0;
      }
      break;
    case 'bottom':
      data.legend.layout = 'horizontal';
      data.legend.verticalAlign = 'bottom';
      data.legend.align = 'left';
      if (options.print) {
        if (options.type === 'bar') {
          data.legend.margin = 4;
          data.chart.spacing[2] += 6;
        } else {
          data.chart.spacing[2] += -2;
        }
      }
      break;
    // case 'right':
    default:
      data.legend.layout = 'vertical';
      data.legend.align = 'right';
      data.legend.verticalAlign = 'middle';
      data.legend.margin = 10;
      break;
  }
  return data;
}

function compileLegendText(data, options) {
  data.legend.labelFormatter = function() {
    const openTag ='<b>', closeTag = '</b>';
    const series = options.series.find(series => series.name === this.name);
    const text = compileText(series, this, options);
    const textBr = element.replaceLineBreaks(text);
    const lines = textBr.split('<br>');
    const boldLegend = element.boldText();
    const bolded = lines.map(line => boldLegend(line, openTag, closeTag));
    return bolded.join('<br>');
  }
}

function styleLegend(data, options) {
  const fontFamilyStyle = options.product === 'financialnews' ? options.styles.font.normal : options.styles.font.semibold;
  const fontFamilyWeight = options.product === 'financialnews' ? options.styles.weight.normal : options.styles.weight.semibold;
  let fontSizePrint = 7.5;
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews') {
      fontSizePrint = options.print && options.sizes['print-fn'].columns <= 2 ? '7.75px' : '12px';
    }
  }
  const fontStyle = options.print ? {
    fontFamily: options.styles.font.normal,
    fontWeight: options.styles.weight.normal,
    fontSize: fontSizePrint
  } : {
    fontFamily: fontFamilyStyle,
    fontWeight: fontFamilyStyle
  }
  let styles = options.styles.get('normal', fontStyle);

  if (__WSJ__) {
    if (options.product === 'wsj') {
      styles = Object.assign({}, {
        fontSize: options.styles.legend.fontSize,
        fontWeight: options.styles.legend.fontWeight,
        lineHeight: options.styles.legend.lineHeight
      });
    }
  }

  if (__MANSIONGLOBAL__) {
    if (options.product === 'mansionglobal') {
      styles = Object.assign({}, {
        fontSize: options.styles.legend.fontSize,
        fontWeight: options.styles.legend.fontWeight,
        lineHeight: options.styles.legend.lineHeight,
        color: options.styles.legend.color
      });
    }
  }

  data.legend.itemStyle = styles;

  if (options.legend.layout === 'right' && !options.forceLegendTop) {
    // if (options.print) {
      const width = options.width * 0.25 - 20;//data.legend.margin;
      data.legend.itemStyle.width = width;//`${width}px`;
    // }
    
    if (options.print) {
      data.legend.margin = 4;
    }
    data.legend.padding = 2;
  } else {
    data.legend.padding = options.print ? 0 : 2;
  }
  data.legend.itemDistance = options.print ? 6 : 12;
  data.legend.itemMarginBottom = options.print ? 4 : 5;
  data.legend.symbolPadding = 7;

  // this doesnt do what you think it does.
  // for some reason this helps space the series name and the series symbol
  data.legend.symbolWidth = options.print ? 4 : 9;

  if (__WSJ__) {
    if (options.product === 'wsj') {
      data.legend.symbolWidth = options.print ? 4 : 7;
    }
  }

  if (!options.print) {
    data.legend.itemStyle.textOverflow = null;
  }
  // data.legend.squareSymbol = false;
  data.legend.symbolHeight = options.print ? 6 : 12;
  data.legend.symbolRadius = 0;
  if (options.type === 'scatter') {
    data.legend.symbolHeight = 24;
    data.legend.symbolRadius = 12;
  }
  const isTooSmallForLineUp = options.series.length > 4 && options.height < 400;
  if (isTooSmallForLineUp) {
    data.legend.verticalAlign = 'middle';
  }

  return data;
}


export function postRender(highchart, options) {
  if (highchart.legend.options.enabled && options.type !== 'scatter') {
    positionLegendContainer(highchart, options);
    let items = highchart.container.querySelectorAll('.highcharts-legend-item');
    disableItems(highchart, options, items);
    formatItems(highchart, options, items);
    if (options.legend.layout === 'right' && items.length) {
      positionRightAlignedItems(highchart, options, items);
    }
    if ((options.type === 'column' || options.type === 'bar') && options.colorMode === 'THRESHOLD' && items.length) {
      styleColorChip(options.series[0], items[0]);
    }
  } else {
    if (options.type === 'scatter' && highchart.legend.options.enabled) {
      const items = highchart.container.querySelectorAll('.highcharts-legend-item');
      disableItems(highchart, options, items);
      positionLegendContainer(highchart, options);
      if (options.legend.layout === 'right' && items.length) {
        positionItemsMiddle(highchart);
      }
      formatScatterLegend(items);
    }
  }
}

function formatScatterLegend(items) {
  items.forEach(item => {
    let editCircle = item.children[1];
    let editCircleDVal = editCircle.getAttribute('d');
    let indexOfFourValue = editCircleDVal.indexOf('4 4');
    editCircleDVal = editCircleDVal.replace('4 4', '5.5 5.5');
    editCircle.setAttribute('d', editCircleDVal);
  })
}

// Resets the legend group Y as items will track data/item paths instead.
// Note that `null` in Highcharts is not the same as `0`.
function positionLegendContainer(highchart, options) {
  const el = highchart.container.querySelector('.highcharts-legend');
  const isBar = options.type === 'bar';
  let x = null;
  let y = null;
  if (options.legend.layout === 'top') {
    y = isBar ? 0 : 0;
    x = options.type === 'scatter' ? 1 : x;
  } else if (options.legend.layout === 'bottom') {
    // y = highchart.spacingBox.height + highchart.legend.itemHeight;
    // y = options.height - parseFloat(options.styles.normal.lineHeight) * 2;
  } else if (options.legend.layout === 'right') {
    y = isBar ? null : 0;
  }
  transform.write(el, 'translate', x, y);
}

// Disable clicks on legend items since the Highcharts behavior is not
// requested and also a bit strange.
function disableItems(highchart, options, items) {
  for (let i = 0; i < highchart.series.length; i++) {
    if (highchart.series[i].legendGroup) {
      highchart.series[i].legendGroup.element.onmouseover = null;
      if (items[i]) items[i].querySelector('text').style.cursor = 'default';
    }
  }
}

// Takes the color in the block and applies it to the text.
function formatItems(highchart, options, items) {
  let x = 0;
  let initX = 0;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    // Draw the key with the correct dimensions:
    let rect = null;
    let path = null;

    if (rect = item.querySelector('rect')) {
      if (options.product !== 'marketwatch') {
        const [height, width, y] = options.product === 'wsj' ? [10, 10, 7] : [13, 9, 5];
        rect.setAttribute('width', options.print ? 4 : width);
        rect.setAttribute('height', options.print ? 6 : height);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', options.print ? 9 : y);
      }
      if (__FINANCIALNEWS__) {
        if (options.product === 'financialnews') {
          const circleX = Number(items[i].children[0].getAttribute('x'));
          const circleY = Number(items[i].children[0].getAttribute('y'));
          const circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
          const positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 11;
          const positionX = options.print ? 0 : 7;
          const circle = highchart.renderer.circle(positionX, positionY , circleRadius).attr({
            fill: items[i].children[1].getAttribute('fill')
          });
          items[i].append(circle.element);
          if (options.print) {
            items[i].children[0].setAttribute('x', circleX + 10 );
          }
          rect.setAttribute('opacity', 0);
        }
      }

      if (__MARKETWATCH__) {
        if ((options.type === 'bar' || options.type === 'area' || options.type === 'column') && options.product === 'marketwatch') {
          rect.setAttribute('width', 13);
          rect.setAttribute('height', 13);
          rect.setAttribute('x', -3);
          rect.setAttribute('y', 5);
        }
      }
    } else if (path = item.querySelector('path')) {
      path.setAttribute('stroke-dasharray', 'none');
      path.setAttribute('stroke-linecap', 'butt');

      if (options.product !== 'marketwatch') {
        path.setAttribute('stroke-width', options.print ? 6 : 13);
        path.setAttribute('d', options.print ?
        'M 0 12 L 4 12' :
        'M 0 11 L 9 11');
      }

      if(__WSJ__){
        if (options.product === 'wsj') {
          path.setAttribute('stroke-width', options.styles.legend.rectHeight);
          path.setAttribute('d', `M 0 12 L ${options.styles.legend.rectWidth} 12`);
        }
      }

      if (__MARKETWATCH__) {
        if (options.type === 'line' && options.product === 'marketwatch') {
          path.setAttribute('stroke-width', 3);
          path.setAttribute('d', 'M 0 11 L 9 11');
        } else if (options.type !== 'line' && options.product === 'marketwatch') {
          path.setAttribute('stroke-width', options.print ? 6 : 13);
          path.setAttribute('d', options.print ?
          'M 0 12 L 4 12' :
          'M 0 11 L 9 11');
        }
      }
      if (__FINANCIALNEWS__) {
        if (options.product === 'financialnews') {
          const itemsChildrenLength = items[i].children.length;
          let pathColorIndex = 0;
          let circleIndex = 1;
          if (itemsChildrenLength === 3) {
            pathColorIndex = 1;
            circleIndex = 2;
          }
          const pathColor = items[i].children[pathColorIndex].getAttribute('stroke');
          const circleX = Number(items[i].children[circleIndex].getAttribute('x'));
          const circleY = Number(items[i].children[circleIndex].getAttribute('y'));
          const circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
          const positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 4;
          const positionX = options.print ? 10 : 8;
          let circle = highchart.renderer.circle(circleX - positionX, circleY - positionY, circleRadius).attr({
            fill: pathColor
          });
          items[i].append(circle.element);
          path.setAttribute('opacity', 0);
          if (options.print) {
            const translateVal = items[i].getAttribute('transform');
            const getLastVal = translateVal.split(',');
            items[i].setAttribute('transform', 'translate(10,' + getLastVal[1]);
          }
        }
      }


    }

    if (options.print) {
      const text = item.querySelector('text');
      text.setAttribute('x', 6);
    }

    if (options.product === 'wsj' && !options.print) {
      const text = item.querySelector('text');
      text.setAttribute('y', 17);
    }

    // Space the items apart. TODO: Figure out how to make Highcharts do this!
    // if (options.legend.layout !== 'right') {
    //   const translate = transform.read(item, 'translate');
    //   if (i === 0) {
    //      initX = translate[0];
    //   }
    //   if (translate[0] <= initX) {
    //     x = 0;
    //   }
    //   transform.write(item, 'translate', translate[0] + x);
    //   x += options.print ? 6 : 12;
    // }
  }
}

function positionRightAlignedItems(highchart, options, items) {
  switch (options.type) {
    case 'area':
    case 'line':
      positionLineItems(highchart, items, options);
      break;
    case 'column':
      positionColumnItems(highchart, items, options);
      break;
    case 'bar':
      positionItemsMiddle(highchart);
      break;
  }
}

function positionLineItems(highchart, items, options) {
  // const isTooSmallForLineUp = options.series.length > 4 && options.height < 400;
  const itemY = getLineItemsY(highchart.container, items, options);
  const botY = highchart.plotTop + highchart.plotHeight;
  positionLegendItems(itemY, items, options, botY, highchart);
  // if (!isTooSmallForLineUp) {
  //   positionLegendItems(itemY, items, options, botY, highchart);
  // } else {
  //   positionItemsMiddle(highchart);
  // } 
}

function positionColumnItems(highchart, items, options) {
  const itemY = getColumnItemsY(highchart.container, items, options);
  const botY = highchart.plotTop + highchart.plotHeight;
  positionItemsMiddle(highchart);
}

// Necessary because Highcharts messes up "middle".
function positionItemsMiddle(highchart) {
  var legendEl = highchart.container.querySelector('g.highcharts-legend');
  var translate = transform.read(legendEl, 'translate');
  var height = legendEl.getBoundingClientRect().height;
  var newY = highchart.plotTop + (highchart.plotHeight - height) / 2;
  transform.write(legendEl, 'translate', translate[0], newY);
}


// Positions the legend items to track data points but not overlap.
function positionLegendItems(itemY, items, options, botY, highchart) {
  const lineHeight = parseFloat(options.styles.lineHeight.normal);
  const midIndex = Math.min(itemY.length - 1, Math.round(itemY.length / 2));
  const margin = 8;//options.print ? 4 : 8;
  let willFit = true;

  // let y = itemY[midIndex].y;
  // for (let i = midIndex - 1; i >= 0; i--) {
  //   let h = items[itemY[i].index].getBoundingClientRect().height + margin;
  //   itemY[i].y = Math.min(itemY[i].y, y - h);
  //   y = itemY[i].y;
  // }
  // y = itemY[midIndex].y +
    // items[itemY[midIndex].index].getBoundingClientRect().height + margin;
  
  // find the Y positions for the corresponding series by matching color
  const legendItemPositions = [...items].map((legendItem, i) => {
    const [el, attr] = options.type === 'line' ? ['path', 'stroke'] : ['rect', 'fill'];
    const colorChip = legendItem.querySelector(el);
    const color = window.getComputedStyle(colorChip).getPropertyValue(attr);
    const match = itemY.find(obj => obj.color === color);
    return { index: i, y: match.y };
  })
  sortItemY(legendItemPositions);
  let y = legendItemPositions[0].y;

  legendItemPositions.forEach(position => {
    position.y = Math.max(position.y, y);
    y = position.y + items[position.index].getBoundingClientRect().height + margin;
  })

  // y = 0;
  // for (let i = 0; i < midIndex; i++) {
  //   itemY[i].y = Math.max(y, itemY[i].y);
  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  // }

  // for (let i = midIndex; i < items.length; i++) {
  //   // let h = y + items[itemY[i - 1].index].getBoundingClientRect().height;// + margin;
  //   itemY[i].y = Math.max(itemY[i].y, y);
  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  // }
  

  legendItemPositions.forEach(position => {
    if (position.y > botY) {
      positionItemsMiddle(highchart)
      willFit = false;
    }
  })

  // Finally, set the Y of the actual legend item element.
  if (willFit) {
    legendItemPositions.forEach(position => {
      if (position.y < botY) {
        transform.write(items[position.index], 'translate', null, position.y);
      }
    })
  }
}


// Returns array of Y positions for each legend item for column charts.
function getColumnItemsY(container, items, options) {
  const fontSize = parseFloat(options.styles.size.normal);
  const seriesEl = container.querySelector('.highcharts-series-group');
  const barsEl = seriesEl.querySelectorAll('.highcharts-series');
  const printOffset = options.print ? -8 : 0;
  let itemY = [];

  for (let i = 0; i < items.length; i++) {
    // Get the path's parent and path Y.
    const g = barsEl[i];
    const rects = g.querySelectorAll('rect');
    const r = rects[rects.length - 1];
    const rY = (rects && rects.length) ?
      (transform.read(g, 'translate')[1] +
        (+r.getAttribute('y') + +r.getAttribute('height') / 2)) :
      fontSize;

    // Combine the results.
    itemY[i] = {
      index: i,
      y: rY - fontSize + printOffset
    };
  }

  return sortItemY(itemY);
}

// Returns array of Y positions for each legend item for line/area charts.
function getLineItemsY(container, items, options) {
  const fontSize = parseFloat(options.styles.size.normal);
  const seriesEl = container.querySelector('.highcharts-series-group');
  const linesEl = seriesEl.querySelectorAll('.highcharts-series');
  const itemY = [];

  for (let i = 0; i < linesEl.length; i++) {
        // Get the path's parent and path Y.
        // var pathEl = seriesEl.querySelector('.highcharts-series.highcharts-series-' + i);
        const [lineIndex, attr] = options.type === 'area' ? [i, 'fill'] :
          [linesEl.length - i - 1, 'stroke'];
        const pathEl = linesEl[lineIndex];
        const pathElY = transform.read(pathEl, 'translate')[1];
        const paths = pathEl.querySelectorAll('path');
        const d = transform.read(paths[0], 'd');
        const color = window.getComputedStyle(paths[0]).getPropertyValue(attr);
        d.sort((a, b) => {
          return b[0] - a[0];
        });
    
        let pathY;
        if (options.type === 'line') {
          pathY = d[0][1];
        } else {
          const dx = d[0][0];
          const d0 = d.filter(item => {
            return item[0] === dx;
          }).sort((a, b) => {
            return a[1] - b[1]
          });
          if (d0.length >= 2) {
            pathY = (d0[d0.length - 1][1] - d0[0][1]) / 2 + d0[0][1];
          } else {
            pathY = d0[0][1];
          }
        }
    
        // Combine the results.
        itemY[i] = {
          index: i,
          y: pathY + fontSize / 2,
          color: color
        };
  }
  return sortItemY(itemY);
}


// Sort on Y and return.
function sortItemY(itemY) {
  itemY.sort((a, b) => {
    return a.y - b.y;
  });
  return itemY;
}

function compileText(series, item, options) {
  const val = options.type === 'scatter' ? series.name : lastItem(item.yData);
  return (series.markdown || '')
    .replace(CATEGORY, options.liveMarketData || options.type === 'scatter' ? 'n/a' : compiledCategory(options) || 'n/a')
    .replace(SERIES, series.name || 'n/a')
    .replace(SYMBOL, item.userOptions.symbol || 'n/a')
    .replace(VALUE, options.liveMarketData ? 'n/a' : val)
    .replace(POINT, options.liveMarketData ? 'n/a' : compiledPoint(item.yData, options));
}

function compiledCategory(options) {
  if (!options.longCategories) return 'n/a';
  return options.categoriesAreDates && options.dates[0].value > lastItem(options.dates).value ?
    options.longCategories[0]
    :
    lastItem(options.longCategories);
}

function compiledPoint(data, options) {
  return lastItem(data) ?
    format.applyFull(lastItem(data), options.tooltips, options.type === 'pie', true, true)
    :
    'null';
}

function lastItem(arr) {
  return typeof arr === 'string' ? arr : arr[arr.length - 1];
}

// split the color chip into two colors for threshold charts
function styleColorChip(series, item) {
  const colorChip = item.querySelector('rect');
  const topColor = series.color;
  const bottomColor = series.negativeColor;
  const [defs, gradient, topStop, bottomStop] =
    [createSvgEl('defs'), createSvgEl('linearGradient'), createSvgEl('stop'), createSvgEl('stop')];
  const gradientAttrs = { 'id': 'lg', 'x2': '0%', 'y2': '100%' };
  setAttrs(gradient, gradientAttrs);
  setOffset(topStop, bottomStop);
  setColor(topStop, topColor);
  setColor(bottomStop, bottomColor);
  gradient.appendChild(topStop);
  gradient.appendChild(bottomStop);
  defs.appendChild(gradient);
  item.appendChild(defs);
  colorChip.setAttribute('fill', 'url(#lg)');
}

function createSvgEl(type) {
  const svgns = 'http://www.w3.org/2000/svg';
  return document.createElementNS(svgns, type);
}

function setAttrs(el, attrs) {
  for (let key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
}

function setOffset(...args) {
  args.forEach(arg => arg.setAttribute('offset', '50%'));
}

function setColor(el, color) {
  el.setAttribute('stop-color', color);
}



// WEBPACK FOOTER //
// ./src/chart/inner/legend.js